import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'modules/views/shared/Modal';
import { ReactComponent as ExclamationRound } from 'assets/images/ExclamationRound.svg';

import { useStyles } from '../styles';

interface IDeclineConfirmationModalProps {
  onClose: () => void;
  isVisible: boolean;
  selectedCompanies: { label: string; value: string }[];
  onDecline: () => void;
}

const DeclineConfirmationModal = ({
  onClose,
  isVisible,
  selectedCompanies,
  onDecline,
}: IDeclineConfirmationModalProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  if (!isVisible) {
    return null;
  }

  return (
    <Modal
      isVisible={isVisible}
      modalStyleClass={classes.modal}
      modalTitleStyleClass={classes.modalTitle}
      modalContentStyleClass={classes.confirmationModalContent}
      modalActionsStyleClass={classes.modalActions}
      testId="decline-confirmation-modal"
      Content={
        <>
          <div className={classes.imageParent}>
            <ExclamationRound />
          </div>
          <p className={classes.warningTitle}>{t('projectList.declineConfirmationModal.title')}</p>
          <p className={classes.warningText}>
            {t('projectList.declineConfirmationModal.message')}

            <p className={classes.companyNames}>{selectedCompanies?.map(company => company.label).join(', ')}</p>
          </p>
        </>
      }
      actionButtons={[
        {
          label: t('common.cancel'),
          variant: 'outlined',
          styleClass: classes.button,
          testId: 'decline-confirmation-cancel-button',
          onClick: onClose,
        },
        {
          label: t('projectList.actions.decline'),
          styleClass: classes.button,
          testId: 'decline-confirmation-decline-button',
          isLoading: false,
          onClick: onDecline,
        },
      ]}
      onClose={onClose}
    />
  );
};

export default DeclineConfirmationModal;
